module.exports = __webpack_public_path__ + "static/img/img-3-1.861b322.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-1.png
// module id = FQPu
// module chunks = 0